import React from 'react';
import { Upload, CheckCircle, RefreshCcw } from 'react-feather';
import LinkButton from 'components/shared/LinkButton';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const UploadStatus = ({
  uploading,
  isFileUploaded,
  message,
  uploadFileName,
  canReplaceFile,
  fileUploadRef,
  uploadProgress,
  processingProgress,
}) => {
  return (
    <div className="ElearningFileUpload-uploadArea ElearningFileUpload-uploadStatus">
      {uploading && (
        <Upload
          className="ElearningFileUpload-icon"
          size="22.5px"
          color="#949499"
          data-testid="uploadingSvg"
        />
      )}
      {isFileUploaded && (
        <CheckCircle
          className="ElearningFileUpload-icon"
          size="22.5px"
          color="#008A1F"
          data-testid="checkCircleSvg"
        />
      )}
      <div>{message}</div>
      <div className="ElearningFileUpload-fileName fw-b">
        {uploadFileName ||
          t('questions.types.elearning.file_upload.loading_file_name')}
      </div>
      {isFileUploaded && canReplaceFile && (
        <div className="mt-12">
          <LinkButton
            className="Underline-on-hover td-n"
            onClick={() => {
              fileUploadRef.current.click();
            }}
          >
            <div className="ElearningFileUpload-replaceFile">
              <RefreshCcw size="16px" color="#4277a4" />
              <Text variant={TEXT_VARIANTS.BODY_LINK}>
                {t('questions.types.elearning.file_upload.replace_file')}
              </Text>
            </div>
          </LinkButton>
        </div>
      )}
      {uploading && (
        <div className="ElearningFileUpload-uploadProgress">
          <div
            className="ElearningFileUpload-uploadProgressBar"
            style={{
              width: `${uploadProgress + processingProgress}%`,
            }}
          />
        </div>
      )}
    </div>
  );
};

export default UploadStatus;
